import React from "react";
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import yellowStar from "../img/yellow-star.png"
const Star = (p) => {
    return <img src={yellowStar} className="little_img"/>
}

export default class UserReviews extends React.Component {

    render() {
        return <div className="user_reviews">
            <h1>Nos assurés sont satisfaits !</h1>
            <Carousel showThumbs={false} showStatus={false} autoPlay={true} interval={6000} swipeable={true} infiniteLoop={true}>
                <div> 
                    <h2>Avis client <Star/><Star/><Star/><Star/><Star/> 5/5</h2>
                    <p>Je suis pleinement satisfaite du service et du suivi client. J'ai assurée ma moto il y a maintenant 1 an et les conseillers sont à l'écoute et proposent une assurance adaptée et personnalisée. Je suis très bien chez vous et recommande Assur Bon Plan. </p>
                    <p className="author">par Lisa Bonpart</p>
                </div>
                <div>
                <h2>Avis client <Star/><Star/><Star/><Star/><Star/> 5/5</h2>
                    <p>Je suis super contente de la qualité des services ! En effet, dès que j’ai eu besoin, ma conseillère a toujours été présente et a répondu à toutes mes demandes et questions. Je recommande vivement cette assurance car ils sont à l’écoute et disponibles ! Très bonne expérience car ce sont vraiment des professionnels ! </p>
                    <p className="author">par Manon Dubois</p>
                </div>
                <div>
                <h2>Avis client <Star/><Star/><Star/><Star/><Star/> 5/5</h2>
                    <p>J’ai beaucoup apprécié la disponibilité du conseiller qui a pris le temps de me proposer les différentes formules. Il a été très réactif concernant mes demandes de plus cela a été le meilleur tarif que j’ai trouvé pour mon scooter.</p>
                    <p className="author">par Alexis Vasseur</p>
                </div>
            </Carousel>
        </div>
    }

}
